import { render, staticRenderFns } from "./ButtonOne.vue?vue&type=template&id=69940742&"
import script from "./ButtonOne.vue?vue&type=script&lang=ts&"
export * from "./ButtonOne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports